import useSWR from 'swr';
import { getAllDeliveryConfigs } from 'services/delivery.service';

// Shared SWR key — the Delivery settings tab calls mutate() on this key after a successful
// outstation save, so the sidebar (a persistent layout component that never remounts between
// navigations) picks up the change without a reload. Same pattern as RETURN_SETTINGS_ENABLED_KEY.
export const OUTSTATION_ENABLED_KEY = 'outstation-shipping-enabled';

const fetchOutstationEnabled = () =>
  getAllDeliveryConfigs().then(
    (response) => response?.data?.configs?.outstation_courier?.isActive === true
  );

// Only fetches when shouldCheck is true — callers that can never show returns
// (wrong role, legal/dental verticals) never fire this request.
export const useOutstationEnabled = (shouldCheck = true) => {
  const { data, isLoading } = useSWR(
    shouldCheck ? OUTSTATION_ENABLED_KEY : null,
    fetchOutstationEnabled,
    // This answer only decides whether one nav item is shown, so a failure degrades to
    // "off" rather than being worth retrying. SWR's default retry-with-backoff meant a
    // single broken /delivery-configs replayed the same 500 on every page the sidebar
    // renders on — including the Website Builder, which shares this layout.
    { shouldRetryOnError: false }
  );

  return {
    outstationEnabled: !!data,
    isLoading: shouldCheck ? isLoading : false,
  };
};
